module.exports = __webpack_public_path__ + "static/media/marker.f437df7e.png";